/** OAuth 2.0 Web client ID (public; safe to embed in the SPA). */
export const GOOGLE_CLIENT_ID_RE = /^[0-9]+-[a-z0-9]+\.apps\.googleusercontent\.com$/i;

/** Deleted, rotated, or placeholder IDs that must not be used (cause invalid_client). */
const BLOCKED_GOOGLE_CLIENT_IDS = new Set([
  '705695813275-roaepb7an7bkq4gn9b7fr5c73vp26303.apps.googleusercontent.com',
  '137273476022-4il1dq3mj28v0g1c2t59mt3l341evlbl.apps.googleusercontent.com',
]);

const PLACEHOLDER_RE = /^(your_|skip$|changeme|xxx|placeholder|test$|fake|dummy|example)/i;

export const GOOGLE_CLIENT_ID_MISSING_MESSAGE =
  'Google sign-in is not configured. Add VITE_GOOGLE_CLIENT_ID to .env.local (see .env.example), restart the dev server, and ensure that OAuth client allows this origin in Google Cloud Console.';

function readRawGoogleClientId(): string | undefined {
  if (typeof import.meta === 'undefined') return undefined;
  const v = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  return typeof v === 'string' && v.trim() ? v.trim() : undefined;
}

export function isValidGoogleOAuthClientId(value: string | undefined | null): value is string {
  if (!value?.trim()) return false;
  const id = value.trim();
  if (!GOOGLE_CLIENT_ID_RE.test(id)) return false;
  if (BLOCKED_GOOGLE_CLIENT_IDS.has(id)) return false;
  if (PLACEHOLDER_RE.test(id) || id.includes('your_google')) return false;
  return true;
}

/** Resolved client ID from VITE_GOOGLE_CLIENT_ID only (no hardcoded fallback). */
export function getGoogleOAuthClientId(): string | null {
  const raw = readRawGoogleClientId();
  return isValidGoogleOAuthClientId(raw) ? raw : null;
}
